<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS300 colorPrincipal font-45">
            MEMORIA RECUPERADA <br>
            <span style="line-height: 100%;" class="fontMS700">
            LOS LIBROS DEVUELTOS <br>
            POR CHILE <br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio32/memoria-recuperada">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio32/memoria-recuperada">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio32/memoria-recuperada">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio32/MEMORIA-000.jpg">
</section>

<div class="fondoBlanco_Intro" >
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center  font-24 ">
                    <br>
                    
                    EL SAQUEO DE LA BIBLIOTECA NACIONAL DEL PERÚ DURANTE LA GUERRA DEL PACÍFICO (1879-1883) 
                    ES UNO DE LOS MOMENTOS MÁS TRÁGICOS DE SU HISTORIA. PRESENTAMOS EL PROCESO DE RECUPERACIÓN 
                    DE LOS LIBROS Y DOCUMENTOS QUE DURANTE MÁS DE UN SIGLO ESTUVIERON EXTRAVIADOS. DE ESTE MODO, 
                    INVITAMOS A REFLEXIONAR SOBRE LA IMPORTANCIA DEL PATRIMONIO DOCUMENTAL Y BIBLIOGRÁFICO EN 
                    LA CONSTRUCCIÓN DE NUESTRA MEMORIA HISTÓRICA. 
                    <br>
                </p>
                <p class="fontMS100 text-center  font-24">
                    <img width="100%" src="/assets/images/micrositio/micrositio32/MEMORIA-001.jpg">
                </p>
                <p class="fontMS300Italic text-left font-18 text-gris">
                    Marca de fuego con la inscripción «Biblioteca <br>
                    Pública de Lima» en el canto superior. 
                </p>
                
            </div>
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
                <p class="fontMS100 text-left font-18 text-gris">
                    En 2007 y 2017, en un gesto de resarcimiento, el hermano país de Chile devolvió parte de 
                    este gran acervo, conformado por 4 mil 699 libros y documentos, que ahora se encuentran 
                    en la Biblioteca Nacional del Perú. 
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS300 text-center colorPrincipal font-40">
                            OCUPACIÓN DE LIMA Y <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">
                    SAQUEO DE LA BIBLIOTECA NACIONAL
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br>
                    EN ENERO DE 1881, LUEGO DE LAS BATALLAS DE SAN JUAN Y MIRAFLORES, EL EJÉRCITO CHILENO INGRESÓ 
                    AL CENTRO DE LA CAPITAL. LA INVASIÓN DE LIMA, ENTRE OTRAS CONSECUENCIAS, ORIGINÓ SAQUEOS Y
                    DESTRUCCIÓN EN DIVERSAS ENTIDADES COMO LA UNIVERSIDAD DE SAN MARCOS, EL PALACIO DE LA 
                    EXPOSICIÓN, LA ESCUELA DE ARTES Y OFICIOS Y LA BIBLIOTECA NACIONAL.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-20 text-left text-gris">
                            Ricardo Palma, quien tuvo la tarea de reconstruir la Biblioteca Nacional, en su 
                            Memoria de 1884 narra lo siguiente: “Desgraciadamente, al regresar a Chile los 
                            principales jefes del ejército de ocupación, quedó Lima bajo el mando superior 
                            del general don Pedro Lagos, el que, en los primeros días de Marzo, cometió el 
                            crimen de lesa-civilización de considerar los libros como botín de guerra, 
                            destruyendo la obra del genio progresista y civilizador de San Martín”.
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-20 text-left text-gris">
                            También explica que durante meses los salones se convirtieron en cuarteles 
                            para los soldados y compara el saqueo con la destrucción de la 
                            Biblioteca de Alejandría.
                        </p>
                        <p class="font-20 text-left text-gris">
                            En 1884, Ricardo Palma solicitó al presidente chileno Domingo Santa María la 
                            devolución de los libros saqueados. De esta manera, consiguió que el gobierno 
                            chileno admitiera el saqueo y logró el retorno a Perú de 624 libros y más de 
                            3 mil códices. 
                        </p>
                    </div>
                    
                    <div class="col-sm-12">
                        <p class="fontMS100 text-center font-24">
                            <img width="100%" src="/assets/images/micrositio/micrositio32/MEMORIA-002.jpg">
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS300Italic text-left font-18 text-gris">
                            Entrada a Lima, por la Calle Mercaderes, 
                            de la primera división del ejército chileno, 
                            al mando del general Cornelio Saavedra. Lima, 
                            17 de enero de 1881.
                        </p>
                    </div>
                    <div class="col-sm-6"></div>
                    
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGrisN">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">           
                    <hr/>                
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row">
            <div class="col-sm-3">
                <p class="text-center">
                    <a href="https://hdl.handle.net/20.500.14428/14796" target="_blank">
                        <img width="100%"
                            src="\assets\images\micrositio\micrositio32\MEMORIA-003.jpg">
                    </a>
                </p>
            </div>
            <div class="col-sm-3">
                <p class="text-center">
                    <a href="https://hdl.handle.net/20.500.14428/21561" target="_blank">
                        <img width="100%"
                            src="\assets\images\micrositio\micrositio32\MEMORIA-004.jpg">
                    </a>
                </p>
            </div>
            <div class="col-sm-3">
                <p class="text-center">
                    <a href="https://hdl.handle.net/20.500.14428/13008" target="_blank">
                        <img width="100%"
                            src="\assets\images\micrositio\micrositio32\MEMORIA-005.jpg">
                    </a>
                </p>
            </div>
            <div class="col-sm-3">
                <p class="text-center">
                    <a href="https://hdl.handle.net/20.500.14428/65110" target="_blank">
                        <img width="100%"
                            src="\assets\images\micrositio\micrositio32\MEMORIA-006.jpg">
                    </a>
                </p>
            </div>
        
            <div class="col-sm-3">
                <p class="text-center">
                    <a href="http://hdl.handle.net/20.500.14428/79293 " target="_blank">
                        <img width="100%"
                            src="\assets\images\micrositio\micrositio32\MEMORIA-007.jpg">
                    </a>
                </p>
            </div>
            <div class="col-sm-3">
                <p class="text-center">
                    <a href="https://hdl.handle.net/20.500.14428/70354" target="_blank">
                        <img width="100%"
                            src="\assets\images\micrositio\micrositio32\MEMORIA-008.jpg">
                    </a>
                </p>
            </div>
            <div class="col-sm-3">
                <p class="text-center">
                    <a href="https://hdl.handle.net/20.500.14428/21584" target="_blank">
                        <img width="100%"
                            src="\assets\images\micrositio\micrositio32\MEMORIA-009.jpg">
                    </a>
                </p>
            </div>
            <div class="col-sm-3">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
                <p class="fontMS500 text-justify font-24">
                    <br>
                    «LA BIBLIOTECA DE LIMA QUE FUE HACE TRES AÑOS, NO SOLO LA MEJOR DE SUD-AMÉRICA, 
                    SINO QUE SE ENCONTRABA A LA ALTURA DE MUCHAS DE LAS PRINCIPALES DE EUROPA POR 
                    LA IMPORTANCIA DE LAS OBRAS QUE LA FORMABAN Y, MÁS QUE TODO, POR EL MÉRITO INDISCUTIBLE 
                    DE LOS PRECIOSOS Y RAROS MANUSCRITOS QUE COMPONÍAN LA COLECCIÓN DE INÉDITOS, 
                    HA DESAPARECIDO CASI POR COMPLETO, PUES DE LOS CINCUENTA MIL VOLÚMENES IMPRESOS 
                    QUE EXISTÍAN EN ELLA, NO LLEGAN A UN MIL LOS QUE AÚN QUEDAN ESPARCIDOS POR LOS 
                    CINCO SALONES QUE OCUPABAN. DE LOS MANUSCRITOS, ENTRE LOS QUE HABÍA NO POCOS DE 
                    LOS SIGLOS XV Y XVI, NO SE ENCUENTRA HOY UNO SOLO, COMO TAMPOCO NINGUNO DE LOS 
                    MAPAS DE LA COLECCIÓN GEOGRÁFICA».
                    <br>
                </p>
                <div class="text-right">
                    <p class="fontMS500Italic text-right font-24">
                        <br>
                        RICARDO PALMA, 1884.
                        <br>
                    </p>
                </div>
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    EL PENSAMIENTO ILUSTRADO EN LA
                </p>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            COLECCIÓN DE SAN MARTÍN <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">
                    
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center text-white font-24">
                    <br>
                    LA CREACIÓN DE LA BIBLIOTECA NACIONAL DEL PERÚ NO FUE UN HECHO AISLADO, PUESTO QUE JOSÉ DE 
                    SAN MARTÍN Y SUS MINISTROS FUNDARON OTRAS INSTITUCIONES EDUCATIVAS Y CULTURALES COMO 
                    LA BIBLIOTECA PÚBLICA GENERAL SAN MARTÍN DE MENDOZA (ARGENTINA), EN LAS CUALES SE 
                    DEPOSITABAN LOS IDEALES DE LA INDEPENDENCIA.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="font-20 text-left text-white">
                            La Biblioteca Nacional se conformó a partir de las colecciones de la biblioteca 
                            del Colegio Máximo de San Pablo y de donaciones particulares. La más significativa 
                            es la de José de San Martín, consistente en 762 libros de diversas materias que 
                            lo acompañaron en su gesta libertadora desde Argentina.
                        </p>
                        <p class="font-20 text-left text-white">
                            San Martín era un hombre humanista e ilustrado. Por tal motivo, en su biblioteca se 
                            destacaban la Enciclopedia, una colección de trabajos de Mirabeau, el diccionario 
                            de Rosier, la Historia filosófica y política, la Historia de los filósofos modernos, 
                            la Filosofía de Gassendi así como las obras de los filósofos franceses Montesquieu y 
                            Voltaire. 
                        </p>
                    </div> 
                </div>

                <div class="row mt-5">
                    <div class="col-sm-3 ">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/12250" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-010.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/63323" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-011.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/64540" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-012.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/11859" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-013.jpg">
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            HISTORIA DEL PERÚ <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">
                    
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center text-gris font-24">
                    <br>
                    ANTES DE LA GUERRA DEL PACÍFICO, LA  BIBLIOTECA NACIONAL DEL PERÚ POSEÍA UNA GRAN COLECCIÓN 
                    DE CRÓNICAS DE INDIAS QUE INCLUÍA LAS DE BERNAL DÍAZ DEL CASTILLO, CIEZA DE LEÓN, LÓPEZ 
                    DE GÓMARA, INCA GARCILASO DE LA VEGA, ENTRE OTROS. 
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="font-20 text-left text-gris">
                            Del mismo modo, destacan las obras sobre personajes y acontecimientos del proceso 
                            emancipador peruano. Por tal motivo, en esta sección se destacan los textos de 
                            Vicente Morales Duárez, Riva-Agüero y Sánchez Boquete, Francisco Javier Mariátegui 
                            y Vicuña Mackenna.
                        </p>
                        <p class="font-20 text-left text-gris">
                            El interés por incrementar la colección de la Biblioteca Nacional se mantuvo, 
                            incluso, antes de la llegada del ejército chileno a Lima. Por tal motivo, 
                            Manuel de Odriozola envió cartas a diversas autoridades para adquirir en el 
                            extranjero las memorias históricas sobre la independencia de Colombia y el Perú 
                            del general Daniel O´Leary. 
                        </p>
                    </div> 
                </div>

                <div class="row mt-5">
                    <div class="col-sm-3 ">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/64418" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-014.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/73513" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-015.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/71364" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-016.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/71381" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-017.jpg">
                            </a>
                        </p>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-sm-3 ">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/72206" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-018.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/71584" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-019.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/63326" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-020.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/73355" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-021.jpg">
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
                <p class="fontMS500 text-justify font-24">
                    <br>
                    "POR PEQUEÑA QUE SEA LA SEMILLA, ELLA PUEDE SER EL GERMEN DE ROBUSTA Y GIGANTESCA ENCINA. 
                    UNA BIBLIOTECA NO DEBE, PUES, APRECIARSE POR LAS APARIENCIAS DEL PRESENTE, SINO POR 
                    LAS PROMESAS QUE ELLA ENCARNA EN EL PORVENIR".
                    <br>
                </p>
                <div class="text-right">
                    <p class="fontMS500Italic text-right font-24">
                        <br>
                        RICARDO PALMA, 1884
                        <br>
                    </p>
                </div>
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            HISTORIA UNIVERSAL<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">
                    
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br>
                    LA HISTORIA SE CONSTITUYÓ EN EL TEMA MÁS DESTACADO DE LOS FONDOS BIBLIOGRÁFICOS DE LA 
                    BIBLIOTECA NACIONAL DEL PERÚ ANTES DE LA GUERRA DEL PACÍFICO. ES ASÍ QUE LA COLECCIÓN 
                    DONADA POR SAN MARTÍN CONTIENE, POR LO MENOS, DOSCIENTOS CINCUENTA VOLÚMENES, REFERIDOS 
                    A LA HISTORIA ANTIGUA (HISTORIA ROMANA, EMPERADORES ROMANOS), LA REVOLUCIÓN FRANCESA Y 
                    LAS GUERRAS NAPOLEÓNICAS (HISTOIRE DU DIRECTORIE EXÉCUTIF DE LA RÉPUBLIQUE FRANÇAISE, 
                    HISTORIA DE LA REVOLUCIÓN DE FRANCIA), E HISTORIA DE ESPAÑA E INDIAS (MONARQUÍA INDIANA 
                    DE TORQUEMADA). 
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="font-20 text-left text-gris">
                            La colección incluyó, asimismo, obras de historia natural como las de Buffon, 
                            Humboldt, Bompland, Ruiz y Pavón, las Floras del Janeiro y de Chile y el Hortus 
                            indicus. Asimismo, se incluyeron obras que presentaron acontecimientos de la Edad 
                            Antigua y la Edad Moderna, tanto en español como en francés. 
                        </p>
                    </div> 
                </div>

                <div class="row mt-5">
                    <div class="col-sm-3 ">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/64543" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-022.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/64270" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-023.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/64249" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-024.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/66059" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-025.jpg">
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA RELIGIOSIDAD <br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    A TRAVÉS DE LOS LIBROS
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center text-white font-24">
                    <br>
                    ANTES DE LA GUERRA CON CHILE, LA BIBLIOTECA NACIONAL DEL PERÚ PONÍA A DISPOSICIÓN DE LOS 
                    LECTORES DIVERSAS, RARAS Y VALIOSAS EDICIONES DE LA BIBLIA COMO, POR EJEMPLO, LA POLÍGLOTA 
                    COMPLUTENSE DE JIMÉNEZ DE CISNEROS, LA DE AMBERES DE ARIAS MONTANO, LA DE LONDRES DE 
                    BRIAT WALTON, LA SIXTINA, LA GLOGOLÍTICA DE LOS RUSOS, LOS EVANGELIOS EN LENGUAS GÓTICA 
                    Y VASCUENSE, LA ANTIGUA BIBLIA ITÁLICA, LAS DE DUHAMEL, SABATIER, VENCE, SASY, SCIO Y AMAT. 
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="font-24 text-white">
                            Asimismo, la Biblioteca conservaba constituciones, 
                            sermones, disertaciones y algunos documentos pontificios. 
                            <br>
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-4 ">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/71680" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-026.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/71677" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-027.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/65292" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-028.jpg">
                            </a>
                        </p>
                    </div>
                </div>


                <div class="row mt-2">
                    <div class="col-sm-4 ">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/65018" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-029.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/34789" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-030.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/75383" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-031.jpg">
                            </a>
                        </p>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LITERATURA <br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal font-40">
                    
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br>
                    ANTES DE LA GUERRA DEL PACÍFICO, LA BIBLIOTECA CONTABA CON LOS CLÁSICOS GRIEGOS 
                    Y LATINOS IMPRESOS EN EL TALLER DE PLANTIN-MORETUS (BÉLGICA), ELZEVIRES,  
                    EN EDICIONES PLANTINAS, ELZEVIRIANAS Y LAS LLAMADAS AD USUM DELPHINI (OBRAS 
                    ASEQUIBLES A TODO PÚBLICO).
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="font-24 text-gris">
                            Por otro lado, en la Sala América se encontraban las obras de autores 
                            que nacieron o residieron en el Perú como, por ejemplo, Caviedes, 
                            Olavide, Peralta y Barnuevo, el Lunarejo, Larriva, Segura y muchos otros. 
                            <br>
                        </p>
                        <p class="font-24 text-gris">
                            Asimismo, se contaba con ejemplares de autores fundamentales de la 
                            literatura universal como Ludovico Ariosto, Moliére y La Fontaine.
                            <br>
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-4 ">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/64250" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-032.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/64529" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-033.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/71595" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-034.jpg">
                            </a>
                        </p>
                    </div>
                </div>


                <div class="row mt-2">
                    <div class="col-sm-4 ">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/71888" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-035.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/74039" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-036.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/75324" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-037.jpg">
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            SAN MARTÍN Y <br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">
                    EL DERECHO
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br>
                    
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="font-24 text-gris">
                            Como se ha anotado, dentro de los fondos bibliográficos de la Biblioteca Nacional 
                            del Perú, previos a la Guerra con Chile, se destaca la donación de José de San Martín. 
                            Entre esas publicaciones, se incluye una serie de volúmenes que se ocupan del derecho 
                            y la legislación. Entre estos debe destacarse una colección de libros sobre 
                            <span class="fontMS100Italic">Juzgados militares y Ciencias y legislación.</span> 
                            Del mismo modo, dicha colección incluye ejemplares 
                            sobre el <span class="fontMS100Italic">Comercio de América y el Comercio de España e Indias.</span>
                            <br>
                        </p>
                        <p class="font-24 text-gris">
                            Asimismo, antes del expolio de la Biblioteca Nacional del Perú, la institución 
                            contaba con alegatos judiciales que datan de la época colonial, en los cuales 
                            participaron personajes reconocidos de la historia de nuestro país como el Conde 
                            de Lemos y el Marqués de Torre Tagle. 
                            <br>
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-4 ">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/13991" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-038.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/72025" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-039.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/72987" 
                            target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-040.jpg">
                            </a>
                        </p>
                    </div>
                </div>


                <div class="row mt-2">
                    <div class="col-sm-4 ">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/12503" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-041.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/72998" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-042.jpg">
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="text-center">
                            <a href="https://hdl.handle.net/20.500.14428/73896" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-043.jpg">
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PERÚ Y CHILE EN DIÁLOGO. <br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">
                    LA RECUPERACIÓN DE LOS LIBROS
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio15\ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br>
                    A PARTIR DEL AÑO 2006, SE REAVIVÓ LA POLÉMICA SOBRE EL SAQUEO DE LOS LIBROS DE 
                    LA BIBLIOTECA NACIONAL DEL PERÚ.<br>
                    DESDE ENTONCES SE EFECTUARON GESTIONES DIPLOMÁTICAS QUE CONCLUYERON CON LA 
                    DEVOLUCIÓN DE 3969 TÍTULOS A LA BIBLIOTECA NACIONAL DEL PERÚ, EN EL MES DE 
                    NOVIEMBRE DE 2007. 

                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="font-24 text-gris">
                            Dichos ejemplares contienen una serie de distintivos que permitieron su 
                            identificación: sellos de tinta, marcas de fuego, exlibris y etiquetas 
                            topográficas.
                            <br>
                        </p>
                        <p class="font-24 text-gris">
                            Posteriormente, entre los meses de noviembre y diciembre de 2017, 
                            la Biblioteca Nacional del Perú recibió 730 títulos.
                            <br>
                        </p>
                        <p class="font-24 text-gris">
                            Estos libros conforman la colección Memoria recuperada, que nos
                            permite reconstruir la historia de la Biblioteca.  
                            <br>
                        </p>
                         
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-6 ">
                        <p class="text-center">
                            <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-044.jpg">
                            <span class="fontMS100Italic text-left" >  
                                Estantes del Fondo Antiguo de la Biblioteca Nacional del Perú con 
                                libros devueltos por Chile<br>
                                en 2007 y 2017.
                                (Foto: Cecilia Larrabure) <br>
                                En: Imaginario y memoria. 200 años de la Biblioteca Nacional del 
                                Perú.<br>
                                Lima: Biblioteca Nacional del Perú, 2021.
                                <br><br> 
                            </span>
                        </p>
                        <p class="text-center">
                            <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-045.jpg">
                            <br><br>
                        </p>
                        <div class="row">
                            <div class="col-sm-4 "></div>
                            <div class="col-sm-8 ">
                                <p class="text-right">
                                    <img width="100%"
                                            src="\assets\images\micrositio\micrositio32\MEMORIA-046.jpg">
                                    <span class="fontMS100Italic text-left" >  
                                        Recepción de los libros devueltos por Chile a la Biblioteca 
                                        Nacional del Perú el 1 de diciembre de 2017.
                                        (Fotos: BNP)
                                        <br><br> 
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-8 ">
                                <p class="text-center">
                                    <img width="100%"
                                            src="\assets\images\micrositio\micrositio32\MEMORIA-047.jpg">
                                    <span class="fontMS100Italic text-left" >  
                                        Etiqueta topográfica de los libros de la Biblioteca Pública de Lima 
                                        saqueados y reubicados en la Biblioteca Nacional de Chile.<br>
                                        Contratapa del libro:  La conjuración de Catilina y la guerra de 
                                        Jugurta / por Cayo Salustio Crispo. -- Madrid : J. Ibarra, impresor, 
                                        1772.
                                        <br><br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-4 "></div>
                        </div>
                        <p class="text-center">
                            <img width="100%"
                                    src="\assets\images\micrositio\micrositio32\MEMORIA-048.jpg">
                            <span class="fontMS100Italic text-center" >  
                                Ejemplar de Théatre de Voltaire, de François Marie Arouet de Voltaire. 
                                París: chez Antoine-Agustin Renouard. El libro pertenece a la colección del 
                                general San Martín, despojado en la Guerra del Pacífico y devuelto por Chile. 
                                Presenta sello de la Biblioteca Nacional de Chile y ex libris de José de
                                 San Martín.<br>
                                (Foto: Cecilia Larrabure) <br>
                                En: Imaginario y memoria. 200 años de la Biblioteca Nacional del Perú. 
                                Lima: Biblioteca Nacional del Perú, 2021.
                                <br><br>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoOrange">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-3">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-40">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <P class="font-24 text-center text-white fontMS300Italic mt-5">
                            PREGUNTAS PARA REFLEXIONAR
                        </P>
                        <img width="100%"
                            src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <p class="text-white text-justify font-24">
                    La devolución del material bibliográfico de Chile al Perú, producto de la Guerra del 
                    Pacífico y la ocupación de Lima iniciada en 1881, fue un complejo proceso en el que 
                    fueron fundamentales las gestiones diplomáticas y el entorno político, que beneficiaron 
                    gestos de reconocimiento y hermandad más allá de las diferencias coyunturales. 
                    <br><br>
                    
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            a)	¿Por qué el saqueo y la destrucción del patrimonio bibliográfico documental 
                            deben ser considerados como delitos de lesa civilización?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            b)	¿Cuál es la importancia de conocer las joyas bibliográficas existentes 
                            en la Biblioteca Nacional del Perú antes de la Guerra del Pacífico?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            c)	¿Por qué las devoluciones de los libros implican un proceso de construcción de la memoria global entre Chile y el Perú? 

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio15/ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio15/ET03_MS010_ANTIGUO_LINEA1-recortada3.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Carcelén, C. y Maldonado, H. (2014). </span><br>
                            <span class="fontMS100Italic text-gris">El saqueo de las Bibliotecas y Archivos de Lima durante la ocupación chilena entre 1881 y 1883. Investigaciones sociales, 8(33), p. 141-153. 
                                Disponible en:  
                            </span>
                            <span class="text-gris"></span><br>
                            <a href="https://revistasinvestigacion.unmsm.edu.pe/index.php/sociales/article/view/10990/9887" 
                            target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Después de 126 años-- volvieron a casa :  </span><br>
                            <span class="fontMS100Italic text-gris">catálogo de los libros devueltos por Chile a la Biblioteca Nacional del Perú. 
                                Lima: Biblioteca Nacional del Perú, 2007. </span>
                            <span class="text-gris"></span><br>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Durand, G. (1972).  </span><br>
                            <span class="fontMS100Italic text-gris">Palma y la Biblioteca Nacional. Revista del Archivo General de la Nación, (1), p. 36-41.
                                Disponible en:  </span>
                            <span class="text-gris"> </span><br>
                            <a href="https://revista.agn.gob.pe/ojs/index.php/ragn/issue/view/36/46"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Garfias, M. (2021). </span><br>
                            <span class="fontMS100Italic text-gris">La Biblioteca Nacional del Perú : 200 años de historia. Lima . Biblioteca Nacional del Perú.
                                Disponible en: 
                                
                            </span>
                            <span class="text-gris"> </span><br>
                            <a href="https://bpdigital.bnp.gob.pe/info/la-biblioteca-nacional-del-peru-200-anos-de-historia-00686965" 
                            target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Guibovich, P. (2009).  </span><br>
                            <span class="fontMS100Italic text-gris">La usurpación de la memoria: el patrimonio documental bibliográfico durante la ocupación chilena de Lima, 1881-1883. Jahrbuch fur Geschichte Lateinamerika, (46), p. 83-107.
                                Disponible en: </span>
                            <span class="text-gris"> </span><br>
                            <a href="https://www.vr-elibrary.de/doi/pdf/10.7767/jbla.2009.46.1.83 " target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Trillo, G. (2019).  </span><br>
                            <span class="fontMS100Italic text-gris">
                                Memoria recuperada: los libros devueltos por Chile al Perú. Fénix: 
                                revista de la Biblioteca Nacional, (47), p. 9-29.
                                Disponible en: 
                            </span>
                            <span class="text-gris"> </span><br>
                            <a href="http://revistafenix.bnp.gob.pe/index.php/fenix/article/view/106/1989"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>